"use client";

import type { FC, PropsWithChildren } from "react";
import { cn } from "../../utils";
import { CarouselItem } from "../carousel";

type Props = PropsWithChildren<{
  revealed: boolean;
}>;

const PromoCarouselSlide: FC<Props> = ({ revealed, children }) => (
  <CarouselItem className="basis-full pl-3 @min-[600px]:basis-1/2 @min-[960px]:basis-1/3">
    <div
      className={cn(
        "transition-transform duration-150 ease-out hover:-translate-y-2 motion-reduce:transition-none",
        !revealed && "[&_img[loading=lazy]]:hidden",
      )}
    >
      {children}
    </div>
  </CarouselItem>
);

export default PromoCarouselSlide;
